import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router(
    {
        // mode: 'history',
        routes: [
            {
                path: '/',
                name: 'ChatDemo',
                component: r => require.ensure([], () => r(require('@/pages/chat-demo/main.vue')), 'ChatDemo')
            },
            {
                path: '/myy', // 慕渊云内嵌智能ai助理
                name: 'ChatDemo2',
                component: r => require.ensure([], () => r(require('@/pages/chat-demo/main-myy.vue')), 'ChatDemo2')
            },
        ]
    }
);



// WEBPACK FOOTER //
// ./src/router/index.js